// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3iP8S","colMin":"styles_colMin__iJTtB"};